import './Price.scss'

const Price = null

export default Price
